import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';

function HeroCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear'
  };

  return (
    <div className="container-fluid p-0 mb-5">
      <Slider {...settings}>
        <div>
          <img className="w-100" src="/img/EquipoAireAcondicionado.jpeg" alt="Climatización" />
          <div className="carousel-caption">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-7 pt-5">
                  <h1 className="display-4 text-white mb-4 animated slideInDown">Servicios de Climatización</h1>
                  <p className="fs-5 text-body mb-4 pb-2 mx-sm-5 animated slideInDown">Diseño, instalación y mantención de sistemas HVAC residenciales e industriales.</p>
                  <Link to="/services" className="btn btn-primary py-3 px-5 animated slideInDown">Saber Más</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <img className="w-100" src="/img/ducteria1.jpeg" alt="Ventilación" />
          <div className="carousel-caption">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-7 pt-5">
                  <h1 className="display-4 text-white mb-4 animated slideInDown">Servicios de Ventilacion y Extraccion</h1>
                  <p className="fs-5 text-body mb-4 pb-2 mx-sm-5 animated slideInDown">Diseño, instalación y mantenimiento de sistemas de flujo de aire según normativa.</p>
                  <Link to="/services" className="btn btn-primary py-3 px-5 animated slideInDown">Saber Más</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <img className="w-100" src="/img/climatizador.jpeg" alt="Refrigeración" />
          <div className="carousel-caption">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-7 pt-5">
                  <h1 className="display-4 text-white mb-4 animated slideInDown">Servicios de Refrigeracion y Mantenimiento Industrial</h1>
                  <p className="fs-5 text-body mb-4 pb-2 mx-sm-5 animated slideInDown">Diseñamos, instalamos y mantenemos sistemas de refrigeración eficientes para procesos productivos exigentes.</p>
                  <Link to="/services" className="btn btn-primary py-3 px-5 animated slideInDown">Saber Más</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  );
}

export default HeroCarousel;